import { useCallback, useEffect, useState } from 'react';

// Service
import OrderService from '../../services/orderService';
import { statesTranslate } from '../../models/OrderEntity';
import useUser from '../user/useUser';

const defaultValues = {
    orders: [],
    totalPage: 1,
    totalResults: 0
}
const useOrders = (filters, autoSearch = true) => {
    const { branch, business } = useUser();
    const [searchResutl, setSearchResult] = useState(defaultValues);

    const [loading, setLoading] = useState(false);

    const FindOrders = useCallback(async (abortController, dynamicFilters = filters) => {
        if (!branch?.country) return

        setLoading(true);
        const req = {
            ...dynamicFilters,
            country: branch.country,
            businessIds: autoSearch 
                ? business.isFranchise ? branch.businessId : null
                : null
        };

        try {
            const res = await OrderService.Search(req, abortController && { signal: abortController.signal });
            setSearchResult({
                orders: res.values,
                totalResults: res.totalResults,
                totalPage: res.totalPage
            });
        } catch (error) {
            console.error("Error fetching orders:", error);
        } finally {
            setLoading(false);
        }
    }, [filters, branch.country]);

    useEffect(() => {
        const abortController = new AbortController();

        if (autoSearch && branch.code) {
            FindOrders(abortController);
        } else if (!filters || (typeof filters === "object" && Object.keys(filters).length === 0)) {
            setSearchResult(defaultValues)
        }

        return () => abortController.abort();
    }, [autoSearch, branch.code, FindOrders]);

    const refreshOrder = async (newOrder) => {
        const { orders, totalPage, totalResults } = searchResutl;
        const order = orders.find(o => o.id === newOrder.id);

        if (order) {
            order.state = newOrder.state;
            order.stateToShow = statesTranslate[newOrder.state];

            setSearchResult({ orders, totalPage, totalResults })
        }
    }

    return {
        ...searchResutl,
        loading,
        refreshOrder,
        FindOrders
    }
}

export default useOrders;